import React, { useState } from 'react'
import { toast } from 'react-toastify';
import apiResponse from '../Interfaces/apiResponse';
import { useCreateUserMutation } from '../API/UserApi';
import { useNavigate } from 'react-router-dom';

function HomeCreateUser() {
    const navigate = useNavigate();
    const [createUser] = useCreateUserMutation();
    const [loading, setLoading] = useState(false);
    const [input, setInput] = useState({
    firstName:"",
    lastName:"",
    userAccessId:2,
    dateCreated:Date.now,
    isActive:true,
    passwordHash:"",
    userName:"",
    email:"",
  });
const handleUserInput = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
  const { name, value } = e.target;
  let processedValue: any = value;
  setInput((prev) => ({
    ...prev,
    [name]: processedValue
  }));
};

 const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) =>{
    e.preventDefault();
      if (loading) return; // Prevent multiple clicks
    setLoading(true);
     try {
        const response:apiResponse =  await createUser(input) 
        if(response.data?.isSuccess == true){
                toast.success('Account Created Successfully!', {
                    position: "top-right", 
                    autoClose: 5000, 
                  });
            navigate("/login");
            }else if(response.data?.exist == true){
              toast.error('Question already exist!', {
                position: "top-right", 
                autoClose: 5000, 
              });
            }
            else{
              toast.error('Something went wrong!', {
                  position: "top-right", 
                  autoClose: 5000, 
                });
            }
          
        } catch (error) {
          console.error('Error:', error);
         
        } finally {
          setLoading(false);
        }
 }
  return (
    <div>
        <div className="container mt-4">
      <h3>Registration Form</h3>
      <form onSubmit={handleSubmit} className="p-3 border rounded">
        <div className="mb-3">
          <label className="form-label">First Name</label>
          <input
            type="text"
            name="firstName"
            className="form-control"
            value={input.firstName}
            onChange={handleUserInput}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Last Name</label>
          <input
            type="text"
            name="lastName"
            className="form-control"
            value={input.lastName}
            onChange={handleUserInput}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Email</label>
          <input
            type="email"
            name="email"
            className="form-control"
            value={input.email}
            onChange={handleUserInput}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">UserName</label>
          <input
            type="text"
            name="userName"
            className="form-control"
            value={input.userName}
            onChange={handleUserInput}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Password</label>
          <input
            type="password"
            name="passwordHash"
            className="form-control"
            value={input.passwordHash}
            onChange={handleUserInput}
            required
          />
        </div>

      

        <button type="submit" className="btn btn-primary w-100">
          Submit
        </button>
      </form>
    </div>
    </div>
  )
}

export default HomeCreateUser